<script type="text/babel">
export default {
    data() {
        return {
            form: new SparkForm({}),
        }
    },

    methods: {
        deleteProfile() {
            swal({
                title: 'Advarsel',
                text: 'Er du sikker på at du vil slette din virksomhed?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ja, slet virksomheden',
                cancelButtonText: 'Nej, luk popup',
                closeOnConfirm: true,
                allowEscapeKey: true,
                allowClickOutside: true,
            }, (isConfirmed) => {
                if (!isConfirmed) {
                    return;
                }

                Spark.sendForm('delete', route('brand.company-settings.destroy').toString(), this.form)
                    .then(response => {
                        console.log('SettingsDeleteBrand destroy success');

                        window.location.href = '/';
                    })
                    .catch(error => {
                        console.error('Error deleting account:', error.message)
                        swal({
                            title: 'Fejl',
                            text: error.message,
                            type: 'error',
                        });
                    });
            });
        },
    },
}
</script>
